/**
 * Created by MRQ on 2016/1/12.
 */
'use strict';
angular.module('cancelSignedModule', [])
    .controller('cancelSignedCtrl', ['$scope', '$location', '$modalInstance', '$validation', '$filter', 'params', 'trsspliceString', 'trsHttpService', 'modalDialog', '$timeout', function($scope, $location, $modalInstance, $validation, $filter, params, trsspliceString, trsHttpService, modalDialog, $timeout) {
        initStatus();

        /**
         * [initStatus description] 初始化状态
         * @return  {[type]}  [return description]
         */
        function initStatus() {
            $scope.status = {
                draftFrom: {
                    29: '归档稿',
                    30: '今日稿',
                    31: '待用稿',
                    32: '今日稿',
                    33: '今日稿',
                    34: '上版稿',
                    35: '已签稿',
                    36: '已签稿',
                    37: '已签稿',
                    38: '已签稿'
                },
                newspaperType: $location.path().split('/')[3],
            };
            $scope.title = params.title;
            $scope.opinionTit = params.opinionTit;
            $scope.items = params.items;
            $scope.isManusCorrShow = false;
            $scope.hasNoManusCorr = false;
            $scope.clickCurrItem = '';
            $scope.params = {
                serviceid: 'mlf_paper',
                PaperId: params.PaperId,
                SrcDocId: params.SrcDocId
            };
            $scope.data = {
                selectedRelatedDraft: params.items,
                currItems: angular.copy(params.items)
            };
            getFlexContentH();
        }

        /**
         * [cancel description] 取消按钮操作
         * @return  {[type]}  [return description]
         */
        $scope.cancel = function() {
            $modalInstance.close(false);
        };

        /**
         * [confirm description] 确定按钮操作
         * @return  {[type]}  [return description]
         */
        $scope.confirm = function() {
            $validation.validate($scope.cancelSignedForm).success(function() {
                if ($scope.items.length > 0) {
                    var transferData = {
                        'items': $scope.items,
                        'opinion': $scope.opinion,
                        'SrcDocIds': trsspliceString.spliceString($scope.items, 'METADATAID', ',')
                    };
                    transferData.SrcBanMianIds = angular.isDefined($scope.items[0].CHNLID) ? trsspliceString.spliceString($scope.items, 'CHNLID', ',') : trsspliceString.spliceString($scope.items, 'CHANNELID', ',');
                    $modalInstance.close(transferData);
                } else {
                    modalDialog.alertType('', '请选择稿件', 'warning', false, function() {});
                }
            });
        };
        $scope.delete = function(item) {
            var flag = false;
            $scope.data.currItems.forEach(function(value, index, arr) {
                if (value.METADATAID == item.METADATAID) {
                    flag = true;
                    return;
                }
            });
            flag ? $scope.items.splice($scope.items.indexOf(item), 1) : $scope.chooseRelatedDraft(item);
        };

        /**
         * [handleTitle description] 处理标题
         * @param {object} [item] [description] 列表数据
         * @return {[type]} [description]
         */
        $scope.handleTitle = function(item) {
            item.TITLE = $('<div>' + item.TITLE + '</div>').text();
        };


        /**
         * [getFlexContentH description]根据body的高度来给弹性布局的主题设置高度
         * @return  {[type]}  [return description]
         */
        function getFlexContentH() {
            $timeout(function() {
                var height = document.getElementsByClassName('man_produ_column_modify')[0].offsetHeight;
                document.getElementsByClassName('flexContent')[0].style.height = height + 'px';
            }, 500);
        }

        /**
         * [manuscriptCorrelationData description]查询关联稿件方法
         * @param  {[type]} item [description]稿件信息
         * @return {[type]}      [description]
         */
        function manuscriptCorrelationData(item) {
            var methodnameObj = {
                29: 'queryReleteDocsInGuiDang',
                30: 'queryRelateDocsInJinRi',
                31: 'queryRelateDocsInDaiYong',
                32: 'queryRelateDocsInJinRi',
                33: 'queryRelateDocsInJinRi',
                34: 'queryRelateDocsInShangBan',
                35: 'queryReleteDocsInYiQianFa',
                36: 'queryReleteDocsInYiQianFa',
                37: 'queryReleteDocsInYiQianFa',
                38: 'queryReleteDocsInYiQianFa'
            };
            $scope.params.methodname = methodnameObj[item.DOCSTATUS];
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.params, 'get').then(function(data) {
                $scope.relationDraft = data;
                $scope.data.selectedRelatedDraft = [];
                for (var i = 0; i < data.length; i++) {
                    for (var j in $scope.items) {
                        if ($scope.items[j].RECID === data[i].RECID) {
                            $scope.data.selectedRelatedDraft.push(data[i]);
                        }
                    }
                }
                $scope.hasNoManusCorr = data == '';
            });
        }

        /**
         * [ManusCorrToggle description]点击关联稿件
         * @param   {[type]}  item  [item description]
         * @return  {[type]}        [return description]稿件信息
         */
        $scope.ManusCorrToggle = function(item) {
            if ($scope.clickCurrItem == '' || $scope.clickCurrItem != item.METADATAID) {
                $scope.isManusCorrShow = true;
                $scope.clickCurrItem = item.METADATAID;
            } else if ($scope.clickCurrItem == item.METADATAID) {
                $scope.isManusCorrShow = false;
                $scope.clickCurrItem = '';
            }
            $scope.params.SrcDocId = item.METADATAID;
            manuscriptCorrelationData(item);
        };

        /**
         * [chooseRelatedDraft description]选择相关联的稿件
         * @param   {[type]}  item  [item description]
         * @return  {[type]}        [return description]
         */
        $scope.chooseRelatedDraft = function(item) {
            var num = $scope.data.selectedRelatedDraft.indexOf(item),
                flag = true,
                num2;
            if (num === -1) {
                $scope.data.selectedRelatedDraft.push(item);
            } else {
                $scope.data.selectedRelatedDraft.splice(num, 1);
            }
            for (var i = 0; i < $scope.items.length; i++) {
                if ($scope.items[i].RECID === item.RECID) {
                    flag = false;
                    num2 = i;
                    break;
                } else {
                    flag = true;
                }
            }
            if (flag) {
                $scope.items.push(item);
            } else {
                $scope.items.splice(num2, 1);
            }
        };

        /**
         * [chooseAllRelateDraft description]全选或者取消全选的操作 
         * @return  {[type]}  [return description]
         */
        $scope.chooseAllRelateDraft = function() {
            if ($scope.data.selectedRelatedDraft.length === $scope.relationDraft.length && $scope.relationDraft.length > 0) {
                $scope.data.selectedRelatedDraft = [];
                for (var i = 0; i < $scope.relationDraft.length; i++) {
                    for (var x in $scope.items) {
                        if ($scope.items[x].RECID === $scope.relationDraft[i].RECID) {
                            $scope.items.splice(x, 1);
                            break;
                        }
                    }
                }
            } else {
                $scope.data.selectedRelatedDraft = [];
                for (var j = 0; j < $scope.relationDraft.length; j++) {
                    $scope.data.selectedRelatedDraft.push($scope.relationDraft[j]);
                    var flag = true;
                    for (var y in $scope.items) {
                        if ($scope.items[y].RECID === $scope.relationDraft[j].RECID) {
                            flag = false;
                        }
                    }
                    if (flag) {
                        $scope.items.push($scope.relationDraft[j]);
                    }
                }
            }
        };
    }
    ]);
